import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { UserState } from './modules/user'
import { PermissionState } from './modules/permission'
import { TagsViewState } from './modules/tags-view'

Vue.use(Vuex)

export interface RootState {
  app: IAppState;
  user: UserState;
  permission: PermissionState;
  tagsView: TagsViewState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<RootState>({})
